import * as React from "react";

import { Label, Textarea } from "@flare/ui/components";
import { cn } from "@flare/ui/utils";

import { Hint } from "./Hint";

export type TextAreaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    error?: boolean;
    hint?: string;
    label?: string;
    name: string;
  };

export const TextAreaInput = React.forwardRef<
  HTMLTextAreaElement,
  TextAreaProps
>(({ className, error, hint, label, name, ...restProps }, ref) => {
  const hasError = Boolean(error);
  const hintId = hint ? `${name}-hint` : undefined;

  return (
    <div className="flex w-full flex-col gap-sp-2">
      {label && <Label htmlFor={name}>{label}</Label>}
      <Textarea
        aria-describedby={hintId}
        aria-invalid={hasError}
        name={name}
        id={name}
        className={cn("h-[200px] resize-none bg-transparent", className)}
        ref={ref}
        {...restProps}
      />
      {hint && (
        <Hint id={hintId} error={hasError}>
          {hint}
        </Hint>
      )}
    </div>
  );
});

TextAreaInput.displayName = "TextArea";
